import Vue from 'vue'
import store from '../store'
import Router from 'vue-router'
import Index from '@/pages/index'
import Login from '@/pages/login'
import Welcome from '@/pages/welcome/index'
import Welcome2 from '@/pages/welcome2/index'
import FullScreen from '@/pages/welcome2/fullScreen'
import Welcome3 from '@/pages/welcome2/index01'
import ReserveCustomer from '@/pages/customer/reserveCustomer'
import CustomerManagement from '@/pages/customer/customerManagement'
import PlanToRemind from '@/pages/customer/planToRemind'
import DetailInfo from '@/pages/customer/detailInfo'
import ProjectProgress from '@/pages/customer/projectProgress'
import ProjectProgress3 from '@/pages/customer/projectProgress3'
import Drawings from '@/pages/customer/drawings'
import ManagerBudget from '@/pages/customer/managerBudget'
import CustomerPayment from '@/pages/customer/customerPayment'
import ProjectLoan from '@/pages/customer/projectLoan'
import Commission from '@/pages/customer/commission'
import DoorCustomer from '@/pages/customer/doorCustomer'
import BudgetContract from '@/pages/customer/budgetContract'
import BudgetExamine from '@/pages/customer/budgetExamine'
import ConstructionContract from '@/pages/customer/constructionContract'
import ProjectManager from '@/pages/customer/projectManager'
import AfterSales from '@/pages/customer/afterSales'
import FlyOrder from '@/pages/customer/flyOrder'
import AllCustomer from '@/pages/customer/all'
import IntentionCustomer from '@/pages/customer/intentionCustomer'
import DesignContractCustomer from '@/pages/customer/designContractCustomer'
import EnterRoom from '@/pages/customer/EnterRoom'
import CustomerReturn from '@/pages/customer/customerReturn'
import CustomerComplaint from '@/pages/customer/customerComplaint'
import AftersaleMaintenance from '@/pages/customer/aftersaleMaintenance'
import EmployeeDefine from '@/pages/administrative/employeeDefine'
import Announcement from '@/pages/administrative/announcement'
import QuotaSearch from '@/pages/quotaSearch/quotaSearch'
import MaterialSearch from '@/pages/materialSearch/materialSearch'
import SuccessfulCases from '@/pages/successfulCases/successfulCases'
import CaseDetail from '@/pages/successfulCases/caseDetail'
import StationDefine from '@/pages/systemDefine/stationDefine'
import ProjectProgressDefine from '@/pages/systemDefine/projectProgressDefine'
import BusinessDefine from '@/pages/systemDefine/businessDefine'
import MaterialDefine from '@/pages/systemDefine/materialDefine'
import QuotaDefine from '@/pages/systemDefine/quotaDefine'
import CompanyDefine from '@/pages/systemDefine/companyDefine'
import ReportDefine from '@/pages/systemDefine/reportDefine'
import PaymentDefine from '@/pages/systemDefine/paymentDefine'
import ReceivablesDefine from '@/pages/systemDefine/receivablesDefine'
import PercentageDefine from '@/pages/systemDefine/percentageDefine'
import WarehouseDefine from '@/pages/systemDefine/warehouseDefine'
import BasicDefine from '@/pages/systemDefine/basicDefine'
import StartInventoryDefine from '@/pages/systemDefine/startInventoryDefine'
import MaterialOrderDefine from '@/pages/systemDefine/materialOrderDefine'
import CustomerViewDefine from '@/pages/systemDefine/customerViewDefine'
import DepartmentAssignDefine from '@/pages/systemDefine/departmentAssignDefine'
import MaterialIn from '@/pages/order/materialIn'
import MaterialInReturned from '@/pages/order/materialInReturned'
import MaterialOut from '@/pages/order/materialOut'
import MaterialOutReturned from '@/pages/order/materialOutReturned'
import ReportLoss from '@/pages/order/reportLoss'
import ReportOverflow from '@/pages/order/reportOverflow'
import AuxiliaryMaterials from '@/pages/order/auxiliaryMaterials'
import AuxiliaryMaterialsReturned from '@/pages/order/auxiliaryMaterialsReturned'
import MainMaterials from '@/pages/order/mainMaterials'
import MainMaterialsReturned from '@/pages/order/mainMaterialsReturned'
import SoftMaterials from '@/pages/order/softMaterials'
import SoftMaterialsReturned from '@/pages/order/softMaterialsReturned'
import MainMaterialsReplenishment from '@/pages/order/mainMaterialsReplenishment'
import InventoryStock from '@/pages/order/inventoryStock'
import RecordedProjectFund from '@/pages/financeManage/recordedProjectFund'
import ProjectDetailedAccount from '@/pages/financeManage/projectDetailedAccount'
import BankAccountDefine from '@/pages/systemDefine/bankAccountDefine'
import InventoryPeriodrDefine from '@/pages/systemDefine/inventoryPeriodrDefine'
import QuotationTemplateDefine from '@/pages/systemDefine/quotationTemplateDefine'
import RoomBagDefine from '@/pages/systemDefine/roomBagDefine'
import PurchaseMaterialPayment from '@/pages/financeManage/purchaseMaterialPayment'
import CashierFlowAccount from '@/pages/financeManage/cashierFlowAccount'
import ReportDemo from '@/pages/report/ReportDemo'
import DecisionCenter from '@/pages/decisionCenter/index'
import Report from '@/pages/decisionCenter/report'
import ElectricAppliance from '@/pages/order/electricAppliance'
import ElectricApplianceReturned from '@/pages/order/electricApplianceReturned'
import ContractMaterials from '@/pages/order/contractMaterials'
import ContractMaterialsReturned from '@/pages/order/contractMaterialsReturned'
import MainMaterialsFree from '@/pages/order/mainMaterialsFree'
import MainMaterialsReturnedFree from '@/pages/order/mainMaterialsReturnedFree'
import ProgressSubmitMustDefine from '@/pages/systemDefine/progressSubmitMustDefine'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      redirect: 'welcome',
      component: Index,
      children: [{
        path: 'welcome',
        component: Welcome,
        name: 'HomePage'
      }]
    },
    {
      path: '/report',
      component: Index,
      children: [{
        path: 'demo',
        component: ReportDemo,
        name: 'ReportDemo',
        meta: {
          title: '欢迎',
          keepAlive: false
        }
      }]
    },
    {
      path: '/welcome',
      component: Index,
      children: [{
        path: 'index',
        component: Welcome,
        name: 'Welcome',
        meta: {
          title: '欢迎',
          keepAlive: false
        }
      }]
    },
    {
      path: '/quotaSearch',
      component: Index,
      children: [{
        path: 'index',
        component: QuotaSearch,
        name: 'QuotaSearch',
        meta: {
          title: '定额查询',
          keepAlive: false
        }
      }]
    },
    {
      path: '/materialSearch',
      component: Index,
      children: [{
        path: 'index',
        component: MaterialSearch,
        name: 'MaterialSearch',
        meta: {
          title: '材料查询',
          keepAlive: false
        }
      }]
    },
    {
      path: '/successfulCases',
      component: Index,
      children: [{
        path: 'index',
        component: SuccessfulCases,
        name: 'SuccessfulCases',
        meta: {
          title: '成功案例',
          keepAlive: true
        }
      }]
    },
    {
      path: '/decisionCenter',
      component: Index,
      children: [{
        path: 'index',
        component: DecisionCenter,
        name: 'DecisionCenter',
        meta: {
          title: '决策中心',
          keepAlive: false
        }
      }, {
        path: 'report',
        component: Report,
        name: 'Report',
        meta: {isAlone: true, isActivated: true}
      }]
    },
    {
      path: '/welcome2',
      component: Index,
      children: [{
        path: 'index',
        component: Welcome2,
        name: 'Welcome2',
        meta: {
          title: '再次欢迎',
          keepAlive: true // 页面若需要缓存，则将keepAlive设为true
        }
      },
      {
        path: 'index01',
        component: Welcome3,
        name: 'Welcome3',
        meta: {
          title: '再次欢迎',
          keepAlive: false
        }
      }]
    },
    {
      path: '/financeManage',
      component: Index,
      children: [{
        path: 'recordedProjectFund',
        component: RecordedProjectFund,
        name: 'RecordedProjectFund',
        meta: {
          keepAlive: false
        }
      }, {
        path: 'projectDetailedAccount',
        component: ProjectDetailedAccount,
        name: 'ProjectDetailedAccount',
        meta: {
          keepAlive: false
        }
      }, {
        path: 'purchaseMaterialPayment',
        component: PurchaseMaterialPayment,
        name: 'PurchaseMaterialPayment',
        meta: {
          keepAlive: false
        }
      }, {
        path: 'cashierFlowAccount',
        component: CashierFlowAccount,
        name: 'CashierFlowAccount',
        meta: {
          keepAlive: false
        }
      }]
    },
    {
      path: '/systemDefine',
      component: Index,
      children: [{
        path: 'stationDefine',
        component: StationDefine,
        name: 'StationDefine',
        meta: {
          title: '岗位权限定义',
          keepAlive: false
        }
      }, {
        path: 'basicDefine',
        component: BasicDefine,
        name: 'BasicDefine',
        meta: {
          title: '基础信息定义',
          keepAlive: false
        }
      }, {
        path: 'projectProgressDefine',
        component: ProjectProgressDefine,
        name: 'ProjectProgressDefine',
        meta: {
          title: '工程进度计划定义',
          keepAlive: false
        }
      }, {
        path: 'businessDefine',
        component: BusinessDefine,
        name: 'BusinessDefine',
        meta: {
          title: '供应商定义',
          keepAlive: false
        }
      }, {
        path: 'materialDefine',
        component: MaterialDefine,
        name: 'MaterialDefine',
        meta: {
          title: '材料及价格定义',
          keepAlive: false
        }
      }, {
        path: 'roomBagDefine',
        component: RoomBagDefine,
        name: 'RoomBagDefine',
        meta: {
          title: '房间包含定义',
          keepAlive: false
        }
      }, {
        path: 'quotationTemplateDefine',
        component: QuotationTemplateDefine,
        name: 'QuotationTemplateDefine',
        meta: {
          title: '报价模板定义',
          keepAlive: false
        }
      }, {
        path: 'quotaDefine',
        component: QuotaDefine,
        name: 'QuotaDefine',
        meta: {
          title: '工程定额定义',
          keepAlive: false
        }
      }, {
        path: 'reportDefine',
        component: ReportDefine,
        name: 'ReportDefine',
        meta: {
          title: '报表定义',
          keepAlive: false
        }
      }, {
        path: 'paymentDefine',
        component: PaymentDefine,
        name: 'PaymentDefine',
        meta: {
          title: '付款通知单定义',
          keepAlive: false
        }
      }, {
        path: 'receivablesDefine',
        component: ReceivablesDefine,
        name: 'ReceivablesDefine',
        meta: {
          title: '收款通知单定义',
          keepAlive: false
        }
      }, {
        path: 'percentageDefine',
        component: PercentageDefine,
        name: 'PercentageDefine',
        meta: {
          title: '项目提成定义',
          keepAlive: false
        }
      }, {
        path: 'warehouseDefine',
        component: WarehouseDefine,
        name: 'WarehouseDefine',
        meta: {
          title: '仓库定义',
          keepAlive: false
        }
      }, {
        path: 'bankAccountDefine',
        component: BankAccountDefine,
        name: 'BankAccountDefine',
        meta: {
          title: '银行账户定义',
          keepAlive: false
        }
      }, {
        path: 'inventoryPeriodrDefine',
        component: InventoryPeriodrDefine,
        name: 'InventoryPeriodrDefine',
        meta: {
          title: '库存过账期间定义',
          keepAlive: false
        }
      }, {
        path: 'startInventoryDefine',
        component: StartInventoryDefine,
        name: 'startInventoryDefine',
        meta: {
          title: '期初库存台账',
          keepAlive: false
        }
      }, {
        path: 'materialOrderDefine',
        component: MaterialOrderDefine,
        name: 'MaterialOrderDefine',
        meta: {
          title: '单据定义',
          keepAlive: false
        }
      }, {
        path: 'departmentAssignDefine',
        component: DepartmentAssignDefine,
        name: 'DepartmentAssignDefine',
        meta: {
          title: '单据定义',
          keepAlive: false
        }
      }, {
        path: 'companyDefine',
        component: CompanyDefine,
        name: 'CompanyDefine',
        meta: {
          title: '公司定义',
          keepAlive: false
        }
      }, {
        path: 'customerViewDefine',
        component: CustomerViewDefine,
        name: 'CustomerViewDefine',
        meta: {
          title: '客户界面定义',
          keepAlive: false
        }
      }, {
        path: 'progressSubmitMustDefine',
        component: ProgressSubmitMustDefine,
        name: 'ProgressSubmitMustDefine',
        meta: {
          title: '流程提交必填项定义',
          keepAlive: false
        }
      }]
    },
    {
      path: '/customer',
      component: Index,
      children: [{
        path: 'reserveCustomer',
        component: ReserveCustomer,
        name: 'ReserveCustomer',
        meta: {
          title: '储备客户',
          keepAlive: true,
          nickName: 'addCustomer'
        }
      }, {
        path: 'doorCustomer',
        component: DoorCustomer,
        name: 'DoorCustomer',
        meta: {
          title: '咨询客户',
          keepAlive: true,
          nickName: 'submitDoorCustomer'
        }
      }, {
        path: 'intentionCustomer',
        component: IntentionCustomer,
        name: 'intention',
        meta: {
          title: '订金客户',
          keepAlive: true,
          nickName: 'submitIntentionCustomer'
        }
      }, {
        path: 'budgetContract',
        component: BudgetContract,
        name: 'BudgetContract',
        meta: {
          title: '概算合同',
          keepAlive: true,
          nickName: 'submitBudgetContract'
        }
      }, {
        path: 'designContractCustomer',
        component: DesignContractCustomer,
        name: 'designContract',
        meta: {
          title: '设计合同客户',
          keepAlive: true,
          nickName: 'submitDesignContractCustomer'
        }
      }, {
        path: 'budgetExamine',
        component: BudgetExamine,
        name: 'BudgetExamine',
        meta: {
          title: '预算审核',
          keepAlive: true
        }
      }, {
        path: 'constructionContract',
        component: ConstructionContract,
        name: 'ConstructionContract',
        meta: {
          title: '施工合同',
          keepAlive: true
        }
      }, {
        path: 'projectManager',
        component: ProjectManager,
        name: 'ProjectManager',
        meta: {
          title: '施工客户',
          keepAlive: true
        }
      }, {
        path: 'afterSales',
        component: AfterSales,
        name: 'AfterSales',
        meta: {
          title: '售后服务',
          keepAlive: true
        }
      }, {
        path: 'flyOrder',
        component: FlyOrder,
        name: 'FlyOrder',
        meta: {
          title: '飞单客户',
          keepAlive: true
        }
      }, {
        path: 'all',
        component: AllCustomer,
        name: 'AllCustomer',
        meta: {
          title: '全部',
          keepAlive: true
        }
      }]
    },
    {
      path: '/administrative',
      component: Index,
      children: [{
        path: 'employeeDefine',
        component: EmployeeDefine,
        name: 'EmployeeDefine',
        meta: {
          title: '公司人员定义',
          keepAlive: false
        }
      }, {
        path: 'announcement',
        component: Announcement,
        name: 'Announcement',
        meta: {
          title: '公司公告发布',
          keepAlive: false
        }
      }]
    },
    {
      path: '/order',
      component: Index,
      children: [{
        path: 'materialIn',
        component: MaterialIn,
        name: 'MaterialIn',
        meta: {
          title: '材料入库单',
          keepAlive: false
        }
      }, {
        path: 'materialInReturned',
        component: MaterialInReturned,
        name: 'MaterialInReturned',
        meta: {
          title: '材料入库退单',
          keepAlive: false
        }
      }, {
        path: 'materialOut',
        component: MaterialOut,
        name: 'MaterialOut',
        meta: {
          title: '材料出库单',
          keepAlive: false
        }
      }, {
        path: 'materialOutReturned',
        component: MaterialOutReturned,
        name: 'MaterialOutReturned',
        meta: {
          title: '材料出库退料单',
          keepAlive: false
        }
      }, {
        path: 'reportLoss',
        component: ReportLoss,
        name: 'ReportLoss',
        meta: {
          title: '库存报损单',
          keepAlive: false
        }
      }, {
        path: 'reportOverflow',
        component: ReportOverflow,
        name: 'ReportOverflow',
        meta: {
          title: '库存报溢单',
          keepAlive: false
        }
      }, {
        path: 'auxiliaryMaterials',
        component: AuxiliaryMaterials,
        name: 'AuxiliaryMaterials',
        meta: {
          title: '辅材调拨单',
          keepAlive: false
        }
      }, {
        path: 'auxiliaryMaterialsReturned',
        component: AuxiliaryMaterialsReturned,
        name: 'AuxiliaryMaterialsReturned',
        meta: {
          title: '辅材调拨退料单',
          keepAlive: false
        }
      }, {
        path: 'mainMaterials',
        component: MainMaterials,
        name: 'MainMaterials',
        meta: {
          title: '主材调拨单',
          keepAlive: false
        }
      }, {
        path: 'mainMaterialsReturned',
        component: MainMaterialsReturned,
        name: 'MainMaterialsReturned',
        meta: {
          title: '主材调拨退料单',
          keepAlive: false
        }
      }, {
        path: 'softMaterials',
        component: SoftMaterials,
        name: 'SoftMaterials',
        meta: {
          title: '软装调拨单',
          keepAlive: false
        }
      }, {
        path: 'softMaterialsReturned',
        component: SoftMaterialsReturned,
        name: 'SoftMaterialsReturned',
        meta: {
          title: '软装调拨退料单',
          keepAlive: false
        }
      }, {
        path: 'mainMaterialsReplenishment',
        component: MainMaterialsReplenishment,
        name: 'MainMaterialsReplenishment',
        meta: {
          title: '主材补货单',
          keepAlive: false
        }
      }, {
        path: 'inventoryStock',
        component: InventoryStock,
        name: 'InventoryStock',
        meta: {
          title: '库存台账',
          keepAlive: false
        }
      }, {
        path: 'electricAppliance',
        component: ElectricAppliance,
        name: 'ElectricAppliance',
        meta: {
          title: '电器调拨单',
          keepAlive: false
        }
      }, {
        path: 'electricApplianceReturned',
        component: ElectricApplianceReturned,
        name: 'ElectricApplianceReturned',
        meta: {
          title: '电器调拨退单',
          keepAlive: false
        }
      }, {
        path: 'contractMaterials',
        component: ContractMaterials,
        name: 'ContractMaterials',
        meta: {
          title: '合同外材料调拨单',
          keepAlive: false
        }
      }, {
        path: 'contractMaterialsReturned',
        component: ContractMaterialsReturned,
        name: 'ContractMaterialsReturned',
        meta: {
          title: '合同外材料调拨退单',
          keepAlive: false
        }
      }, {
        path: 'mainMaterialsFree',
        component: MainMaterialsFree,
        name: 'MainMaterialsFree',
        meta: {
          title: '主材调拨单(自由单)',
          keepAlive: false
        }
      }, {
        path: 'mainMaterialsReturnedFree',
        component: MainMaterialsReturnedFree,
        name: 'MainMaterialsReturnedFree',
        meta: {
          title: '主材调拨退料单(自由单)',
          keepAlive: false
        }
      }]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/customerManagement',
      component: Index,
      meta: {
        title: '管理',
        keepAlive: true
      },
      children: [{
        path: '',
        component: CustomerManagement,
        name: 'CustomerManagement',
        meta: {isAlone: true, isActivated: true}
      }, {
        path: 'detailInfo',
        component: DetailInfo,
        name: 'DetailInfo',
        meta: {isAlone: true, isActivated: true}
      }, {
        path: 'planToRemind',
        component: PlanToRemind,
        name: 'PlanToRemind',
        meta: {isAlone: true, isActivated: true}
      }, {
        path: 'projectProgress',
        component: ProjectProgress,
        name: 'ProjectProgress',
        meta: {isAlone: true, isActivated: true}
      }, {
        path: 'projectProgress3',
        component: ProjectProgress3,
        name: 'ProjectProgress3',
        meta: {isAlone: true, isActivated: true}
      }, {
        path: 'drawings',
        component: Drawings,
        name: 'Drawings',
        meta: {isAlone: true, isActivated: true}
      }, {
        path: 'customerReturn',
        component: CustomerReturn,
        name: 'CustomerReturn',
        meta: {isAlone: true, isActivated: true}
      }, {
        path: 'customerComplaint',
        component: CustomerComplaint,
        name: 'CustomerComplaint',
        meta: {isAlone: true, isActivated: true}
      }, {
        path: 'aftersaleMaintenance',
        component: AftersaleMaintenance,
        name: 'AftersaleMaintenance',
        meta: {isAlone: true, isActivated: true}
      }, {
        path: 'enterRoom',
        component: EnterRoom,
        name: 'EnterRoom',
        meta: {isAlone: true, isActivated: true}
      }, {
        path: 'managerBudget',
        component: ManagerBudget,
        name: 'ManagerBudget',
        meta: {isActivated: true, isAlone: true}
      }, {
        path: 'customerPayment',
        component: CustomerPayment,
        name: 'CustomerPayment',
        meta: {isAlone: true, isActivated: true}
      }, {
        path: 'projectLoan',
        component: ProjectLoan,
        name: 'ProjectLoan',
        meta: {isAlone: true, isActivated: true}
      }, {
        path: 'commission',
        component: Commission,
        name: 'Commission',
        meta: {isAlone: true, isActivated: true}
      }]
    },
    {
      path: '/caseDetail',
      component: Index,
      meta: {
        title: '客户详情',
        keepAlive: true
      },
      children: [{
        path: '',
        component: CaseDetail,
        name: 'CaseDetail',
        meta: {isAlone: true, isActivated: true}
      }]
    },
    /**
     *  缓存参照页
     *  isAlone: true   ===>   没有menu和navbar的全屏页面
     *  isActivated： true   ===>  返回上个页面的时候使用缓存数据
     */
    {
      path: '/fullScreen',
      component: Index,
      children: [{
        path: '',
        component: FullScreen,
        name: 'FullScreen',
        meta: {isAlone: true, isActivated: true}
      }]
    }
  ]
})
router.beforeEach((to, from, next) => {
  console.log(to)
  console.log(next)
  if (to.name !== 'Login' && to.name !== 'Report') {
    if (store.state.user === null || store.state.token === null || store.state.user === undefined || store.state.token === undefined || store.state.token === '') {
      next('/login')
    }
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js